import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'leaflet-routing-machine/dist/leaflet-routing-machine.js';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';


// 🔥 إصلاح الماركر
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});


// 🔥 Routing Component
function Routing({ location, destination, setInfo }) {
  const map = useMap();
  const routingRef = useRef(null);
  const isReadyRef = useRef(false);

  useEffect(() => {
    // 🛑 تأكد القيم جاهزة 100%
    if (
      !map ||
      !location.latitude ||
      !destination.latitude ||
      isNaN(location.latitude) ||
      isNaN(destination.latitude)
    ) return;

    // ✅ إنشاء مرة واحدة فقط
    if (!routingRef.current) {
      routingRef.current = L.Routing.control({
        router: L.Routing.osrmv1({
          serviceUrl: 'https://router.project-osrm.org/route/v1',
        }),
        waypoints: [],
        lineOptions: {
          styles: [{ color: 'blue', weight: 5 }],
        },
        addWaypoints: false,
        draggableWaypoints: false,
        show: false,
      }).addTo(map);

      routingRef.current.on('routesfound', function (e) {
        const route = e.routes[0];

        const distance = (route.summary.totalDistance / 1000).toFixed(2);
        const time = Math.round(route.summary.totalTime / 60);

        setInfo({ distance, time });
      });
    }

    // 🛑 لا تحدّث إلا مرة واحدة فقط بعد الجاهزية
    if (!isReadyRef.current) {
      routingRef.current.setWaypoints([
        L.latLng(location.latitude, location.longitude),
        L.latLng(destination.latitude, destination.longitude),
      ]);

      isReadyRef.current = true;
    }

  }, [location, destination, map]);

  return null;
}


export default function TowLocation(props) {
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [routeInfo, setRouteInfo] = useState(null);

  // ✅ استخدام props مباشرة
  const destination = {
    latitude: props.lat,
    longitude: props.long,
  };

  // 🔥 جلب الموقع مباشرة
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  return (
    <div style={{ width: '90%' }}>

      {/* 📏 المسافة والوقت */}
      {routeInfo && (
        <div className='d-flex gap-3 mt-3'>
          <p>📏 Distance: {routeInfo.distance} km</p>
          <p>⏱️ Time: {routeInfo.time} minutes</p>
        </div>
      )}

      {/* 🗺️ الخريطة */}
      {location.latitude && destination.latitude && (
        <MapContainer
          center={[location.latitude, location.longitude]}
          zoom={13}
          style={{ height: '400px', width: '100%', marginTop: '20px' }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          {/* 📍 موقعك */}
          <Marker position={[location.latitude, location.longitude]}>
            <Popup>Your Location</Popup>
          </Marker>

          {/* 📍 الهدف */}
          <Marker position={[destination.latitude, destination.longitude]}>
            <Popup>Destination</Popup>
          </Marker>

          {/* 🛣️ المسار */}
          <Routing
            location={location}
            destination={destination}
            setInfo={setRouteInfo}
          />
        </MapContainer>
      )}
    </div>
  );
}